import { CrossIcon } from '@tymbe/ty-components/icons';
import Modal from 'react-modal';
import ShiftCreate from './components/ShiftCreate/ShiftCreate';
import queryClient from '../../queryClient';
import { queryKeyContains } from '../../utils/reactQueryUtils';
import useSearchString from '../../hooks/UrlParamsHandler/useSearchParams';

type CalendarPageShiftCreateModalProps = {
  showCreateModal: boolean;
  setShowCreateModal: React.Dispatch<React.SetStateAction<boolean>>;
};

export const CalendarPageShiftCreateModal = ({
  setShowCreateModal,
  showCreateModal,
}: CalendarPageShiftCreateModalProps) => {
  const [searchParams] = useSearchString();

  const departmentIdFromURL =
    Number(searchParams.get('department_id')) || undefined;

  return (
    <Modal
      isOpen={showCreateModal}
      shouldCloseOnOverlayClick={false}
      shouldCloseOnEsc={false}
      ariaHideApp={false}
      className="fixed top-6 right-6 bottom-6 left-6 bg-bg rounded-lg overflow-auto drop-shadow-lg z-50 flex flex-col"
      overlayClassName="bg-overlay fixed inset-0 z-modal"
      onRequestClose={() => setShowCreateModal(false)}
    >
      <CrossIcon
        onClick={() => setShowCreateModal(false)}
        className="absolute right-6 top-6 cursor-pointer"
      />
      <ShiftCreate
        departmentId={departmentIdFromURL!}
        onPublish={() => {
          queryClient.invalidateQueries({
            predicate: queryKeyContains('calendar'),
          });
          setShowCreateModal(false);
        }}
        onCancel={() => {
          setShowCreateModal(false);
        }}
      />
    </Modal>
  );
};
